import { ToolConfig } from "src/apps/hr-config-management/types/ToolConfig";

export const IT_TOOLS: ToolConfig[] = [
  {
    name: "Steel Application Access",
    description: "Steel Applications that allows authorized personnel to create, modify, assign roles, and deactivate user accounts",
    requiredRoles: ["ITAdmin.SteelTool.Write"],
  },
  {
   name: "Safety Compliance",
   description: "Allows administrators to grant select users role access to specified safety compliance roles",
   requiredRoles: ["ITAdmin.TaskerTool.Write"],
  },
];